import { useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CompanySearch from "../../components/contract/CompanySearch";
import { createSubContract } from "../../api/contract/sub";
import TableCell from "../../components/common/ui/TableCell";
import AttachmentBox from "../../components/common/papers/AttachmentBox";

const Sub_new = () => {
  const [form, setForm] = useState({
    contract_code: "",
    title: "",
    confirmer_company_name: "",
    amount: "",
    status: "DRAFT",
    // construction_type_detail: "GENERAL",
    memo: "",
    activities: [],
    manualCompanyInput: false,
    construction_type: "본공사",
  });

  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { id: projectId } = useParams();
  const attachmentRef = useRef(null);

  // const form.construction_type = location.state?.construction_type || "본공사";

  const handleAmountChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    setForm({ ...form, amount: raw });
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 저장 처리
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("project", projectId);
      fd.append("contract_code", form.contract_code);
      fd.append("title", form.title);
      fd.append("confirmer_company_name", form.confirmer_company_name);
      fd.append("amount", form.amount);
      fd.append("status", form.status);
      fd.append("construction_type", form.construction_type);
      fd.append("construction_type_detail", form.construction_type_detail);
      fd.append("memo", form.memo);

      form.activities.forEach((act) => fd.append("activity_ids", act.id));

      const res = await createSubContract(fd);
      const dnsId = typeof res.dns === "object" ? res.dns.id : res.dns;

      await attachmentRef.current?.save(dnsId);

      alert("하도급 계약이 등록되었습니다.");
      navigate(`../sub`);
    } catch (err) {
      console.error(err);
      alert("등록 실패");
    }
  };

  return (
    <div className=" p-6 ">
      {/* ===== 페이지 제목 ===== */}
      <div className="mb-6">
        <h2 className="text-title">하도급 계약 등록</h2>
        <div className="h-px bg-gray-300 mt-2"></div>
      </div>

      {/* ===== 상단 버튼 ===== */}
      <div className="flex justify-end mb-4">
        <button type="submit" form="contract-form" className="btn-save">
          등록
        </button>
      </div>

      <form id="contract-form" onSubmit={handleSubmit} className="space-y-6">
        <div className="overflow-x-auto ">
          <table className="min-w-full border-collapse text-sm">
            <tbody>
              {/* 계약코드 / 계약명 */}
              <tr>
                <TableCell
                  label="계약 코드"
                  editing
                  input={
                    <input
                      type="text"
                      name="contract_code"
                      value={form.contract_code}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />

                <TableCell
                  label="계약명"
                  editing
                  input={
                    <input
                      type="text"
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />
              </tr>

              {/* 금액 / 상태 */}
              <tr>
                <TableCell
                  label="계약 금액"
                  editing
                  input={
                    <input
                      type="text"
                      name="amount"
                      value={
                        form.amount
                          ? Number(form.amount).toLocaleString("ko-KR")
                          : ""
                      }
                      onChange={handleAmountChange}
                      className="input-base text-right"
                      placeholder="금액 입력(원)"
                    />
                  }
                />

                <TableCell
                  label="상태"
                  editing
                  input={
                    <select
                      name="status"
                      value={form.status}
                      onChange={handleChange}
                      className="input-base"
                    >
                      <option value="DRAFT">Draft (임시)</option>
                      <option value="FOR_INFORMATION">
                        For Information (정보)
                      </option>
                      <option value="FOR_REVIEW">For Review (검토)</option>
                      <option value="FOR_APPROVAL">For Approval (승인)</option>
                      <option value="FINAL">Final (최종)</option>
                      <option value="AS_BUILT">As-Built (준공)</option>
                      <option value="NO_LONGER_IN_USE">
                        No Longer In Use (폐기)
                      </option>
                    </select>
                  }
                />
              </tr>

              {/* 업체 / 세부 공종 */}
              <tr>
                <TableCell
                  label="주계약업체"
                  editing
                  input={
                    <div className="flex items-center gap-2 w-full">
                      {/* 직접입력 체크 */}
                      <label className="flex items-center gap-1">
                        <input
                          type="checkbox"
                          checked={form.manualCompanyInput}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              manualCompanyInput: e.target.checked,
                              confirmer_company_name: "",
                            })
                          }
                        />
                        <span className="text-sm">직접 입력</span>
                      </label>

                      {/* 입력 UI */}
                      {form.manualCompanyInput ? (
                        <input
                          type="text"
                          name="confirmer_company_name"
                          value={form.confirmer_company_name}
                          onChange={handleChange}
                          className="input-base flex-1"
                          placeholder="업체명 입력"
                        />
                      ) : (
                        <div className="flex flex-1 gap-2">
                          <input
                            readOnly
                            value={form.confirmer_company_name}
                            placeholder="업체 선택"
                            className="input-base bg-gray-100 flex-1"
                          />
                          <button
                            type="button"
                            onClick={() => setModalOpen(true)}
                            className="btn-edit px-3"
                          >
                            검색
                          </button>
                        </div>
                      )}

                      <CompanySearch
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                        onSelect={(company) =>
                          setForm({
                            ...form,
                            confirmer_company_name: company.name,
                            manualCompanyInput: false,
                          })
                        }
                      />
                    </div>
                  }
                />
                {/* 공종 */}
                <TableCell
                  label="공종"
                  editing
                  input={
                    <div>
                      <input
                        type="text"
                        name="construction_type"
                        value={form.construction_type}
                        onChange={handleChange}
                        className="w-full border rounded-md px-3 py-2"
                        placeholder="공종을 입력하세요"
                      />
                    </div>
                  }
                />
                {/* <TableCell
                  label="세부 공종"
                  editing
                  input={
                    <select
                      name="construction_type_detail"
                      value={form.construction_type_detail}
                      onChange={handleChange}
                      className="input-base"
                    >
                      <option value="GENERAL">General (일반)</option>
                      <option value="ARCHITECTURAL">Architectural (건축)</option>
                      <option value="STRUCTURAL">Structural (구조)</option>
                      <option value="CIVIL">Civil (토목)</option>
                      <option value="LANDSCAPING">Landscaping (조경)</option>
                      <option value="MECHANICAL">Mechanical (기계)</option>
                      <option value="ELECTRICAL">Electrical (전기)</option>
                      <option value="COMMUNICATION">Communication (통신)</option>
                      <option value="FIREFIGHTING">Firefighting (소방)</option>
                      <option value="INTERIOR">Interior (인테리어)</option>
                      <option value="OTHERS">기타</option>
                    </select>
                  }
                /> */}
              </tr>

              {/* 특이사항 */}
              <tr>
                <TableCell
                  label="특이사항"
                  editing
                  colSpan={3}
                  input={
                    <textarea
                      name="memo"
                      value={form.memo}
                      onChange={handleChange}
                      className="input-base h-40 resize-none"
                    />
                  }
                />
              </tr>
            </tbody>
          </table>
        </div>

        {/* 첨부파일 */}
        <div className="bg-white border rounded-xl p-4">
          <label className="text-sm font-semibold">첨부파일</label>
          <AttachmentBox ref={attachmentRef} />
        </div>
      </form>
    </div>
  );
};

export default Sub_new;
